module.exports = __webpack_public_path__ + "static/media/galeria9.feefe5d5.jpg";